/* Roasterland theme behaviour — small, dependency-free. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Mobile menu drawer
  function initDrawer() {
    $$('[data-drawer-open]').forEach((btn) => {
      const drawer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!drawer) return;
      const close = () => { drawer.hidden = true; btn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; btn.focus(); };
      btn.addEventListener('click', () => {
        drawer.hidden = false; btn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden';
        const first = drawer.querySelector('a, button'); if (first) first.focus();
      });
      $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
      drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    });
  }

  // Search bar toggle
  function initSearch() {
    $$('[data-search-toggle]').forEach((btn) => {
      const bar = document.getElementById(btn.getAttribute('aria-controls'));
      if (!bar) return;
      btn.addEventListener('click', () => {
        bar.hidden = !bar.hidden; btn.setAttribute('aria-expanded', String(!bar.hidden));
        if (!bar.hidden) { const i = bar.querySelector('input'); if (i) i.focus(); }
      });
    });
  }

  // Tabs (region explorer, brew guide)
  function initTabs() {
    $$('[data-tabs]').forEach((root) => {
      const tabs = $$('[role="tab"]', root);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          next.focus(); select(next);
        });
      });
    });
  }

  // Product gallery
  function initGallery(root) {
    const slides = $$('[data-slide]', root);
    const controls = $$('[data-slide-to]', root);
    const show = (id) => {
      slides.forEach((s) => { s.hidden = s.dataset.slide !== String(id); });
      controls.forEach((c) => c.setAttribute('aria-current', String(c.dataset.slideTo === String(id))));
    };
    controls.forEach((c) => c.addEventListener('click', () => show(c.dataset.slideTo)));
    // Swipe on mobile
    const main = $('.gallery__main', root);
    if (main && slides.length > 1) {
      let x0 = null;
      main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        const cur = slides.findIndex((s) => !s.hidden);
        const next = slides[(cur + (dx < 0 ? 1 : slides.length - 1)) % slides.length];
        show(next.dataset.slide);
      });
    }
    return show;
  }

  // Product form: variants, selling plans, quantity, price
  function initProduct() {
    $$('[data-product]').forEach((root) => {
      const dataEl = $('[data-product-json]', root);
      if (!dataEl) return;
      const data = JSON.parse(dataEl.textContent);
      const form = $('form[data-product-form]', root);
      const idInput = $('input[name="id"]', form);
      const planInput = $('input[name="selling_plan"]', form);
      const showSlide = initGallery(root);
      const fmt = (cents) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency }).format(cents / 100); }
        catch (e) { return '$' + (cents / 100).toFixed(2); }
      };
      const qtyInputs = $$('[data-qty-input]', root);
      const getQty = () => Math.max(1, parseInt(qtyInputs[0] ? qtyInputs[0].value : 1, 10) || 1);

      function currentVariant() {
        const chosen = $$('[data-option-index]', root).reduce((acc, input) => {
          if (input.checked) acc[input.dataset.optionIndex] = input.value; return acc;
        }, {});
        return data.variants.find((v) => v.options.every((o, i) => chosen[i] === undefined || chosen[i] === o)) || data.variants[0];
      }
      function currentPlan(variant) {
        const sel = $('input[name="purchase_type"]:checked', root);
        if (!sel || sel.value !== 'subscribe') return null;
        const freq = $('[data-plan-select]', root);
        const planId = freq ? freq.value : null;
        return variant.plans.find((p) => String(p.id) === String(planId)) || variant.plans[0] || null;
      }
      function update() {
        const v = currentVariant();
        const plan = currentPlan(v);
        idInput.value = v.id;
        if (planInput) planInput.value = plan ? plan.id : '';
        const unit = plan ? plan.price : v.price;
        const qty = getQty();
        $$('[data-price]', root).forEach((el) => { el.textContent = fmt(unit); });
        $$('[data-compare]', root).forEach((el) => {
          const was = plan ? v.price : v.compare_at_price;
          el.textContent = was && was > unit ? fmt(was) : '';
        });
        $$('[data-unit]', root).forEach((el) => { el.textContent = v.unit || ''; });
        $$('[data-cup-price]', root).forEach((el) => {
          if (!v.grams) return;
          el.textContent = fmt(Math.round(unit * 15 / v.grams));
          const note = $('[data-cup-note]', root);
          if (note) note.textContent = Math.floor(v.grams / 15) + ' cups in a ' + v.grams + ' g bag, at 15 g a cup. A café pour-over is about $5.';
        });
        $$('[data-cta]', root).forEach((btn) => {
          btn.disabled = !v.available;
          btn.textContent = !v.available ? data.strings.soldOut : (plan ? data.strings.subscribe : data.strings.add) + ' · ' + fmt(unit * qty);
        });
        $$('[data-plan-wrap]', root).forEach((w) => { w.hidden = !plan; });
        if (v.media_id && showSlide) showSlide(v.media_id);
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('input, select', root).forEach((el) => el.addEventListener('change', update));
      $$('[data-qty-step]', root).forEach((btn) => btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.qtyStep, 10);
        const next = Math.max(1, getQty() + step);
        qtyInputs.forEach((i) => { i.value = next; });
        update();
      }));
      qtyInputs.forEach((i) => i.addEventListener('input', () => { qtyInputs.forEach((o) => { if (o !== i) o.value = i.value; }); update(); }));
      // The sticky mobile bar submits the main form
      $$('[data-submit-product]', root).forEach((b) => b.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit()));
      update();
    });
  }

  // Collection filters: auto-submit, mobile drawer
  function initFilters() {
    $$('[data-filter-form]').forEach((form) => {
      $$('input[type="checkbox"], select', form).forEach((el) => el.addEventListener('change', () => form.submit()));
    });
    $$('[data-filters-open]').forEach((btn) => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', () => { panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
      $$('[data-filters-close]', panel).forEach((c) => c.addEventListener('click', () => { panel.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }));
    });
    $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
      const url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); window.location.href = url.toString();
    }));
  }

  // Cart quantity steppers submit the cart form
  function initCart() {
    $$('[data-cart-step]').forEach((btn) => btn.addEventListener('click', () => {
      const input = document.getElementById(btn.getAttribute('aria-controls'));
      if (!input) return;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.cartStep, 10));
      input.form.submit();
    }));
  }


  // Mega menu: opens on hover (mouse) or first tap/click (touch, keyboard)
  function initMega() {
    const root = $('[data-mega-root]');
    if (!root) return;
    const scrim = $('[data-mega-scrim]');
    const triggers = $$('[data-mega-trigger]', root);
    let open = null, timer = null;
    const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function close() {
      if (!open) return;
      open.panel.hidden = true; open.trigger.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.hidden = true; open = null;
    }
    function show(trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      if (open && open.panel !== panel) close();
      panel.hidden = false; trigger.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.hidden = false; open = { panel, trigger };
    }
    triggers.forEach((t) => {
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (hoverable) {
        t.parentElement.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(() => show(t), 80); });
        t.parentElement.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(close, 160); });
        if (panel) {
          panel.addEventListener('mouseenter', () => clearTimeout(timer));
          panel.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(close, 160); });
        }
      } else {
        t.addEventListener('click', (e) => {
          if (open && open.trigger === t) return; // second tap follows the link
          e.preventDefault(); show(t);
        });
      }
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && !(open && open.trigger === t))) {
          e.preventDefault(); show(t); const first = panel && panel.querySelector('a'); if (first) first.focus();
        }
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) { const t = open.trigger; close(); t.focus(); } });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('click', (e) => { if (open && !root.contains(e.target)) close(); });
  }


  // Coffee profile: match badge and "Tried it?" ratings on product pages
  function initRate() {
    $$('[data-rate]').forEach((root) => {
      if (!window.RLProfile) return;
      const coffee = JSON.parse($('[data-rate-coffee]', root).textContent);
      const match = $('[data-match]', root);
      const show = () => {
        if (!window.RLProfile.exists()) return;
        const r = window.RLProfile.score(coffee);
        match.innerHTML = '<b>' + r.s + '% match</b> for your taste' + (r.why[0] ? ' · ' + r.why[0] : '');
        match.hidden = false;
      };
      show();
      $$('[data-rate-w]', root).forEach((b) => b.addEventListener('click', () => {
        window.RLProfile.learn(coffee, parseFloat(b.dataset.rateW), 'rate-' + coffee.u);
        $$('[data-rate-w]', root).forEach((o) => o.setAttribute('aria-pressed', String(o === b)));
        $('[data-rate-done]', root).hidden = false;
        show();
        if (window.gtag) gtag('event', 'coffee_rating', { item_name: coffee.t, rating: b.textContent });
      }));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDrawer(); initSearch(); initMega(); initRate(); initTabs(); initProduct(); initFilters(); initCart();
    $$('[data-gallery]:not([data-product] [data-gallery])').forEach(initGallery);
  });
})();

/* Finder "Start my ritual" lands on the product with ?ritual=1: preselect subscribe when the product has plans. */
(function () {
  if (!/[?&]ritual=1/.test(location.search)) return;
  var r = document.querySelector('input[name="purchase_type"][value="subscribe"]');
  if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
})();

/* Mobile finder entry points: the floating cup (fills as you scroll) and the menu mini-game. */
(function () {
  var fab = document.querySelector('[data-fab]');
  if (fab) {
    var hasProfile = window.RLProfile && window.RLProfile.exists();
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('rl_fab_done') === '1'; } catch (e) {}
    if (!hasProfile && !dismissed) {
      fab.hidden = false;
      var fill = fab.querySelector('[data-fab-fill]'), title = fab.querySelector('[data-fab-title]'), ticking = false;
      var paint = function () {
        ticking = false;
        var max = document.documentElement.scrollHeight - innerHeight;
        var f = max > 0 ? Math.min(1, scrollY / max) : 0;
        fill.style.height = Math.round(f * 100) + '%';
        if (f >= 0.92 && !fab.classList.contains('is-full')) { fab.classList.add('is-open', 'is-full'); title.textContent = 'Your cup’s ready'; }
      };
      addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
      paint();
      fab.addEventListener('click', function (e) {
        if (!fab.classList.contains('is-open')) { e.preventDefault(); fab.classList.add('is-open'); return; }
        try { sessionStorage.setItem('rl_fab_done', '1'); } catch (er) {}
        if (window.gtag) gtag('event', 'finder_entry', { entry: 'fab', full: fab.classList.contains('is-full') });
      });
    }
  }

  var game = document.querySelector('[data-dgame]');
  if (game) {
    var Q = [
      ['Morning snack?', ['Dark chocolate', 'A little bitter', 'choc'], ['Strawberries', 'Sun-warm, juicy', 'fruit']],
      ['Pick a drink', ['Lemonade', 'Tart and bright', 'bright'], ['Hot cocoa', 'Thick and cozy', 'cozy']]
    ];
    var r = 0, picks = [];
    var q = game.querySelector('[data-dgame-q]'), step = game.querySelector('[data-dgame-step]');
    var opts = [].slice.call(game.querySelectorAll('[data-dgame-opt]'));
    var play = game.querySelector('[data-dgame-play]'), done = game.querySelector('[data-dgame-done]');
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    var show = function () {
      if (r >= Q.length) {
        var fruity = picks.filter(function (k) { return k === 'fruit' || k === 'bright'; }).length;
        game.querySelector('[data-dgame-verdict]').textContent = fruity >= 2 ? 'You’re a Berry Bandit.' : fruity === 1 ? 'Bright, but cozy. Interesting.' : 'Cocoa Loyalist, we see you.';
        game.querySelector('[data-dgame-go]').href = game.dataset.href + (game.dataset.href.indexOf('?') > -1 ? '&' : '?') + 'pre=' + picks.join(',');
        step.textContent = 'Nice picks'; play.hidden = true; done.hidden = false; return;
      }
      step.textContent = (r + 1) + ' of 2 · quick game';
      q.textContent = Q[r][0];
      opts.forEach(function (b, i) { var o = Q[r][i + 1]; b.className = 'dgame__opt dgame__opt--' + o[2]; b.innerHTML = '<b>' + esc(o[0]) + '</b><small>' + esc(o[1]) + '</small>'; b.dataset.k = o[2]; });
      q.classList.remove('is-flip'); void q.offsetWidth; q.classList.add('is-flip');
      play.hidden = false; done.hidden = true;
    };
    opts.forEach(function (b) { b.addEventListener('click', function () { picks.push(b.dataset.k); r++; show(); }); });
    game.querySelector('[data-dgame-again]').addEventListener('click', function () { r = 0; picks = []; show(); });
    game.querySelector('[data-dgame-go]').addEventListener('click', function () { if (window.gtag) gtag('event', 'finder_entry', { entry: 'menu_game', picks: picks.join(',') }); });
    show();
  }
})();
